const headersTable = [
	{ name: 'From', size: 1, sort: true, keyName: 'fromTimestamp' },
	{ name: 'Till', size: 1, sort: true, keyName: 'toTimestamp' },
	{ name: 'Reason', size: 1, sort: false, keyName: '' },
	{ name: 'Created', size: 1, sort: true, keyName: 'createdAt' },
	{ name: 'Booked off by', size: 1, sort: false, keyName: '' },
	{ name: 'Note', size: 2, sort: false, keyName: '' },
];

export { headersTable };
